// @owners { team: patients }
import { post } from '~shared/helpers/apiHelper';
import { getErrorMessageFromResponse } from '~shared/helpers/helper';
import { useMutation } from '~shared/react-query';

export type SurveyResponsePayload = {
  data?: Array<Record<string, unknown>>; // defined as jsonb column in survey_response model
  name: string;
  uuid?: string;
  survey_uuid?: string;
  version: number;
};

/**
 * Submit a survey response (e.g. shipment rating). Resolves on success; rejects on API error.
 */
export const useSubmitSurveyResponse = () => {
  return useMutation({
    mutationFn: async (payload: SurveyResponsePayload) => {
      const response = await post('/survey_responses', payload);
      if (response.error) {
        throw new Error(getErrorMessageFromResponse(response));
      }
      return response;
    },
  });
};
